import { Module } from 'vuex';
import { ITag } from '@/types/Tag';
import { RootState } from '@/store/store';
import { actions } from '@/tags/store/tag.actions';
import { mutations } from '@/tags/store/tag.mutations';

export const namespace: string = 'tags';
const namespaced: boolean = true;

export interface ITagState {
  tags: ITag[];
  loading: boolean;
  loaded: boolean;
}

export const state: ITagState = {
  tags: [],
  loading: false,
  loaded: false,
};

export const tags: Module<ITagState, RootState> = {
  state,
  namespaced,
  actions,
  mutations,
};
